import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MenuItem, Select } from '@material-ui/core';
import { getBlurredText } from '../../utils';

const useStyles = makeStyles(() => ({
  root: {
    height: 30,
    width: '100%',
    maxWidth: 226,
    padding: 0,
    margin: 0,
    fontSize: '0.9rem',
    fontWeight: 400,
    backgroundColor: 'var(--color-white)',

    '& .MuiSelect-iconOutlined': {
      right: 0,
    },

    '& .MuiSelect-root': {
      height: 30,
      padding: 0,
      display: 'block',
      paddingLeft: 6,
      paddingRight: 18,
      boxSizing: 'border-box',
      paddingTop: 6,
    },

    '& .MuiSelect-select': {
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },

    '&.MuiOutlinedInput-root': {
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--color-colorDefault-main)',
        },
      },
    },

    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        outline: 'none',
        border: '1px solid',
        borderColor: 'var(--color-colorDefault-main)',
      },
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--color-colorDefault-main)',
    },

    '& .MuiSelect-icon': {
      color: 'var(--color-fontColors-dark)',
    },

    '&.MuiOutlinedInput-root.Mui-disabled': {
      backgroundColor: 'var(--color-backgroundColors-disabled)',
      color: '#929292',

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--color-colorDefault-main)',
      },
    },

    '& .label-value': {
      textDecoration: 'none !important',
      color: 'inherit',
    },
  },
  MenuItem: {
    textDecoration: 'none !important',
    color: 'inherit',
  },
}));

const BrokerSelectValueRender = ({
  brokersDataAll,
  value,
  blurClientId = false,
}) => {
  const { label = '' } =
    brokersDataAll.find((v) => v.value === value) &&
    brokersDataAll.find((v) => v.value === value).label
      ? brokersDataAll.find((v) => v.value === value)
      : '';

  const [clientId = '', brokerName = ''] = label.split(' - ');

  let brokerText = label ? label : 'Select Client ID / Broker';

  if (label && blurClientId && !value?.startsWith('forward-testing-')) {
    brokerText = `${getBlurredText(clientId)} - ${brokerName}`;
  }

  return <span className="label-value">{brokerText}</span>;
};

const BrokerSelect = ({
  broker,
  brokersDataAll,
  status,
  loading,
  brokerChange,
  blurClientId = false,
  readOnly = false,
}) => {
  const classes = useStyles();

  const handleChange = (event) => {
    brokerChange(event.target.value);
  };

  return (
    <Select
      className={classes.root}
      value={broker}
      onChange={handleChange}
      variant="outlined"
      disabled={status === 'TRADE_ACTIVE' || status === 'READY' || loading}
      displayEmpty
      readOnly={readOnly}
      renderValue={(value) => (
        <BrokerSelectValueRender
          blurClientId={blurClientId}
          value={value}
          brokersDataAll={brokersDataAll}
        />
      )}
    >
      <MenuItem value="" disabled>
        Select Client ID / Broker
      </MenuItem>
      {brokersDataAll.map((o) => (
        <MenuItem value={o.value} key={o.value} className={classes.MenuItem}>
          {o.brokerDisabled ? `${o.label} (disabled)` : `${o.label}`}
        </MenuItem>
      ))}
    </Select>
  );
};

export default BrokerSelect;
